import PropTypes from 'prop-types';
import Button from './ui/Button';
import Surface from './ui/Surface';
import useCalendly from '../hooks/useCalendly';

export default function SectionCTA({
  title,
  eyebrow,
  buttonText = 'Schedule a Call',
  onClick,
  buttonHref,
  variant = 'primary',
  className = 'mt-12'
}) {
  const { open } = useCalendly();
  const buttonOffsetClass = variant === 'ghost' ? '' : 'focus:ring-offset-cam-ivory';

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
      return;
    }
    if (variant === 'primary' && !buttonHref) {
      open();
    } else if (buttonHref) {
      window.location.href = buttonHref;
    }
  };

  return (
    <Surface className={`${className} flex flex-col items-start justify-between gap-6 bg-cam-ivory/40 p-6 md:flex-row md:items-center md:p-8`}>
      <div className="max-w-2xl space-y-2 text-slate-900">
        {eyebrow && <p className="text-sm font-semibold uppercase tracking-wide text-cam-blue/70">{eyebrow}</p>}
        <h3 className="text-xl font-semibold tracking-tight md:text-3xl">{title}</h3>
      </div>
      <Button
        variant={variant}
        className={`w-full sm:w-auto ${buttonOffsetClass}`}
        type="button"
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </Surface>
  );
}

SectionCTA.propTypes = {
  title: PropTypes.string.isRequired,
  eyebrow: PropTypes.string,
  buttonText: PropTypes.string,
  buttonHref: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'secondary', 'ghost']),
  className: PropTypes.string
};
